module.exports = __webpack_public_path__ + "img/mic-off.5e01f868.svg";